import _ from 'lodash';
import Promise from 'bluebird';
import getHelpers from '../helpers';
const api = getHelpers('api');

// initial state
if (_.has(window.store, 'cart')) {
    trackingEvent('cart.init', {
        cart: _.get(window.store, 'cart.attributes', null),
    });
}

const state = {
    favourite_product_entries: [],
    ...window.store,
    notifications: [],
    product: null,
    timestamp: Date.now(),
}

// getters
const getters = {
    stores: (state) => state.stores,
    customer: (state) => state.customer,
    cart: (state) => state.cart,
    carts: (state) => state.carts,
    quote: (state) => state.quote,
    quotes: (state) => state.quotes,
    free_shipping: (state) => state.free_shipping,
    shipping_threshold: (state) => state.shipping_threshold,
    shipping_cost: (state) => state.shipping_cost,
    express_cost: (state) => state.express_cost,
    disable_rural: (state) => state.disable_rural,
    disable_bulky: (state) => state.disable_bulky,
    product: (state) => state.product,
    notifications: (state) => state.notifications,
    timestamp: (state) => state.timestamp,
    pathNodes: (state) => state.pathNodes,
    favourite_product_entries: (state) => state.favourite_product_entries,
    route: (state) => (name, params) => {
        let path = '/' + _.get(state, ['routes', name]);

        _.forEach(params, (value, key) => {
            path = _.replace(path, new RegExp(`{${key}[?]?}`), value);
        })

        return path;
    },
}

const actions = {
    setProduct({ commit }, res) {
        commit('setProduct', res);
        return res;
    },

    getProduct({ commit }, pid) {
        return api.getData(`/product/${pid}`, {
            include: 'prices,attributes,images'
        }).then(res => {
            commit('setProduct', res);
            return res;
        });
    },

    // checkEmailAccount({ commit }, data) {
    //     return api
    //         .postData(`/../customer/verify-email`, {}, {email: data})
    //         .then(res => {
    //             console.log('no problem here!');
    //             this.autoCompleteEmailLogin();
    //             return Promise.resolve(email);
    //         })
    //         .catch(e => {
    //             this.accountExistsError = _.get(e, 'response.data.message', e.message);
    //             return Promise.reject(e);
    //         });
    // },

    registerCustomer({ commit }, data) {
        return api
            .postData(`/../register`, {}, data)
            .then(res => {
                trackingEvent('customer.register', {
                    formParams: (new URLSearchParams(data)).toString(),
                    customer: _.get(res, 'attributes', null),
                });

                commit('addNotification', {
                    type: 'message',
                    message: 'Your account has been created',
                });
                commit('updateProfile', res);
                return res;
            })
    },

    subscribeMailingList({ commit }, data) {
        return api
            .postData(`/../customer/subscriber`, {}, data)
            .then(res => {
                trackingEvent('customer.subscribe', {
                    formParams: (new URLSearchParams(data)).toString(),
                    subscriber: _.get(res, 'attributes', null),
                });

                /*commit('addNotification', {
                    type: 'message',
                    message: 'You have been added to our mailing list',
                });*/
                return res;
            })
    },

    updateProfile({ commit }, data) {
        return api
            .patchData(`/my/profile`, {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Profile update success',
                });
                commit('updateProfile', res);
                return res;
            })
    },

    updateCustomer({ commit, state }, data) {
        const customerId = _.get(state, 'customer.id');
        return api
            .patchData(`/my/customer/${customerId}`, {}, { origin: data })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Profile update success',
                });
                commit('updateCustomer', res);
            })
    },

    createOrder({ commit }, data) {
        return api.postData(`/my/orders`, {}, data)
            .then(res => {
                // commit('addNotification', {
                //     type: 'message',
                //     message: 'Your order is ready',
                // });
                commit('setOrder', res);
                return res;
            })
    },

    /** Cart functions */

    setCart({ commit }, cart) {
        return api
            .getData(`/my/cart`, {
                cart_id: cart.id,
                include: 'items',
            })
            .then(res => {
                commit('setCart', res);
                return res;
            })
    },

    updateCart({ commit }, data) {
        return api
            .patchData(`/my/cart`, {
                include: 'items',
            }, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Cart update sucessfully',
                });
                commit('updateCart', res);
                return res;
            })
            .catch(e => {
                // commit('addNotification', {
                    // type: 'error',
                    // message: _.get(e, 'response.data.message', 'Could not update cart'),
                // });
                throw e;
            });
    },

    updateCartDryrun({ commit }, data) {
        return api
            .patchData(`/my/cart`, {}, { ...data, dryrun: 1 })
            .then(res => {
                commit('updateCartAttributes', res);
                return res;
            })
    },

    createCart({ commit }, data) {
        return api
            .postData(`/my/carts`, {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'New cart has been created',
                });
                commit('createCart', res);
                return res;
            })
    },

    deleteCart({ commit }, id) {
        return api
            .delData(`/my/cart/${id}`)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Cart has been deleted',
                });
                commit('deleteCart', res);
                return res;
            })
    },

    getCartItems({ commit }, payload) {
        const { cart_id } = payload;
        return api.getData(`/my/cart/items`, { cart_id })
            .then(res => {
                commit('setCartItems', res);
                return res;
            })
    },

    setCartItems({ commit }, cartItems) {
        commit('setCartItems', cartItems);
    },

    createCartItem({ commit, state }, payload) {
        let { cart_id, item } = payload;

        return api.postData(`/my/cart/items`, {}, _.merge({ cart_id }, item || {}))
            .then((res) => {
                item = res;
                return api.getData(`/my/cart/items`, { cart_id });
            })
            .then(res => {

                const shipThresh = parseFloat(_.get(state, 'shipping_threshold', 300));
                const freeShip = _.get(state, 'free_shipping', true);

                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('setCartItems', res);

                // custom message
                const cart = state.cart.attributes;
                let notMsg = 'It\'s in the bag<br>You&apos;ve made a great choice today<br>Your cart has been updated';

                let cartHasCollect = cart.items.find(item => item.collect === 1);
                let cartHasStoreDel = cart.items.find(item => !_.isNull(item.store_id));

                if (freeShip && _.isUndefined(cartHasCollect) && _.isUndefined(cartHasStoreDel)) {
                    if (cart.summary.subtotal <= shipThresh) {
                        notMsg += '<br>Only $' + parseFloat(shipThresh - cart.summary.subtotal).toFixed(2) + ' until free shipping<br><i><small>(Excludes rural address)</small></i>';
                    } else {
                        notMsg += '<br>You\'ve earnt free shipping<br><i><small>(Excludes rural address)</small></i>';
                    }
                }

                commit('addNotification', {
                    title: 'Brilliant!',
                    type: 'message',
                    message: notMsg
                });

                // sharpspring
                trackingEvent('cart.item.create', {
                    item: _.get(item, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                })

                // ga
                trackingEvent('ga.add_to_cart', {
                    item: _.get(item, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                    item_price: _.get(item, 'attributes.item_price'),
                });

                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not add cart item'),
                });
                throw e;
            });
    },

    updateCartItem({ commit, dispatch }, payload) {
        const { cart_id, item } = payload;

        return api.patchData(`/my/cart/item/${item.id}`, {}, _.merge({ cart_id }, item || {}))
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Item has been updated',
                });
                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('updateCartItems', [
                    { id: res.id, $updated: res }
                ]);

                trackingEvent('cart.item.update', {
                    item: _.get(res, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                });
                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not add cart item'),
                });

                // refresh cart here
                api.getData(`/my/cart`, {
                    cart_id: cart_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateCart', res);
                })

                throw e;
            });
    },

    deleteCartItem({ commit }, payload) {
        const { cart_id, item } = payload;
        return api.delData(`/my/cart/item/${item.id}`, { cart_id })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Item has been removed',
                });
                commit('setCartAttribute', _.get(res, 'included.parent'));
                commit('updateCartItems', [
                    { id: res.id, $deleted: true }
                ]);

                trackingEvent('cart.item.delete', {
                    item: _.get(res, 'attributes', null),
                    cart: _.get(res, 'included.parent.attributes', null),
                });
                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not delete cart item'),
                });

                // refresh cart here
                api.getData(`/my/cart`, {
                    cart_id: cart_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateCart', res);
                })

                throw e;
            });
    },

    /** Quote functions */

    setQuote({ commit }, quote) {
        return api
            .getData(`/my/quote`, {
                quote_id: quote.id,
                include: 'items',
            })
            .then(res => {
                commit('setQuote', res);
                return res;
            })
    },

    updateQuote({ commit }, data) {
        let quote = null;

        return api
            .patchData(`/my/quote`, {}, data)
            .then((res) => {
                quote = res;
                return api.getData('/my/quotes', {
                    sort: 'created_at:desc',
                    per_page: 99999,
                })
            })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Quote updated sucessfully',
                });

                commit('setQuotes', res);
                return quote;
            })
            .catch(e => {
                // commit('addNotification', {
                    // type: 'error',
                    // message: _.get(e, 'response.data.message', 'Could not update quote'),
                // });
                throw e;
            });
    },

    updateQuoteDryrun({ commit }, data) {
        return api
            .patchData(`/my/quote`, {}, { ...data, dryrun: 1 })
            .then(res => {
                commit('updateQuoteAttributes', res);
                return res;
            })
    },

    createQuote({ commit }, data) {
        let quote = null;

        return api
            .postData(`/my/quotes`, {}, data)
            .then((res) => {
                quote = res;
                return api.getData('/my/quotes', {
                    sort: 'created_at:desc',
                    per_page: 99999,
                })
            })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'A new quote has been created',
                });

                commit('setQuotes', res);
                return quote;
            })
    },

    deleteQuote({ commit }, id) {
        return api
            .delData(`/my/quote`, { quote_id: id })
            .then(() => api.getData('/my/quotes', {
                sort: 'created_at:desc',
                per_page: 99999,
            }))
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Quote has been deleted',
                });

                commit('setQuotes', res);
                return res;
            })
    },

    getQuoteItems({ commit }, payload) {
        const { quote_id } = payload;
        return api.getData(`/my/quote/items`, { quote_id })
            .then(res => {
                commit('setQuoteItems', res);
                return res;
            })
    },

    setQuoteItems({ commit }, quoteItems) {
        commit('setQuoteItems', quoteItems);
    },

    createQuoteItem({ commit }, payload) {
        let { quote_id, item } = payload;

        return api.postData(`/my/quote/items`, {}, _.merge({ quote_id }, item || {}))
            .then((res) => {
                item = res;
                return api.getData(`/my/quote/items`, { quote_id });
            })
            .then(res => {
                commit('addNotification', {
                    title: 'Brilliant!',
                    type: 'message',
                    message: 'We’ve added a shiny new item to your quote',
                });
                commit('setQuoteAttribute', _.get(res, 'included.parent'));
                commit('setQuoteItems', res);

                trackingEvent('quote.item.create', {
                    item: _.get(item, 'attributes', null),
                    quote: _.get(res, 'included.parent.attributes', null),
                })
                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not add quote item'),
                });
                throw e;
            });
    },

    updateQuoteItem({ commit, dispatch }, payload) {
        let { quote_id, item } = payload;

        return api.patchData(`/my/quote/item/${item.id}`, {}, _.merge({ quote_id }, item || {}))
            .then((res) => {
                item = res;
                return api.getData(`/my/quote/items`, { quote_id });
            })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Item has been updated',
                    duration: 3000,
                });
                commit('setQuoteAttribute', _.get(res, 'included.parent'));
                commit('setQuoteItems', res);
                commit('updateQuoteItems', [
                    { id: res.id, $updated: res }
                ]);

                trackingEvent('quote.item.update', {
                    item: _.get(res, 'attributes', null),
                    quote: _.get(res, 'included.parent.attributes', null),
                });
                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not add quote item'),
                });

                // refresh quote here
                api.getData(`/my/quote`, {
                    quote_id: quote_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateQuote', res);
                })

                throw e;
            });
    },

    updateQuoteItems({ commit, dispatch }, payload) {
        let { quote_id, data } = payload;

        return api.putData(`/my/quote/items`, {}, _.merge({ quote_id, data }))
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Item has been updated',
                    duration: 3000,
                });

                return api.getData(`/my/quote/items`, { quote_id })
            })
            .then(res => {
                commit('setQuoteItems', res);
                commit('setQuoteAttribute', _.get(res, 'included.parent'));

                trackingEvent('quote.item.update', {
                    item: _.get(res, 'attributes', null),
                    quote: _.get(res, 'included.parent.attributes', null),
                });

                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not add quote item'),
                });

                // refresh quote here
                api.getData(`/my/quote`, {
                    quote_id: quote_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateQuote', res);
                })

                throw e;
            });
    },

    deleteQuoteItem({ commit }, payload) {
        let { quote_id, item } = payload;
        return api.delData(`/my/quote/item/${item.id}`, { quote_id })
            .then((res) => {
                item = res;
                return api.getData(`/my/quote/items`, { quote_id });
            })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Item has been removed',
                    duration: 3000,
                });
                commit('setQuoteAttribute', _.get(res, 'included.parent'));
                commit('setQuoteItems', res);
                commit('updateQuoteItems', [
                    { id: res.id, $deleted: true }
                ]);

                trackingEvent('quote.item.delete', {
                    item: _.get(res, 'attributes', null),
                    quote: _.get(res, 'included.parent.attributes', null),
                });
                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not delete quote item'),
                });

                // refresh quote here
                api.getData(`/my/quote`, {
                    quote_id: quote_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateQuote', res);
                })

                throw e;
            });
    },

    addQuoteItemsToCart({ commit }, payload) {
        const { quote_id } = payload;

        return api.postData(`/my/quote/addToCart`, {}, _.merge({ quote_id }))
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Items have been added to your cart',
                });

                commit('setCart', res);
                return res;
            })
            .catch(e => {
                commit('addNotification', {
                    type: 'error',
                    message: _.get(e, 'response.data.message', 'Could not add quote item'),
                });

                // refresh quote here
                api.getData(`/my/quote`, {
                    quote_id: quote_id,
                    include: 'items',
                })
                .then(res => {
                    commit('updateQuote', res);
                })

                throw e;
            });
    },

    addItemToQuotes({ commit }, payload) {
        const { quote_ids, item } = payload;

        return Promise.all(_.map(quote_ids, quote_id => {
            return api.postData(`/my/quote/items`, {}, _.merge({ quote_id }, item || {}))
        }))
        .then(() => api.getData('/my/quotes', {
            sort: 'created_at:desc',
            per_page: 99999,
        }))
        .then(res => {
            commit('addNotification', {
                type: 'message',
                message: 'Item has been added to your quotes',
            });
            console.log(res);
            commit('setQuotes', res);
            return res;
        })
        .catch(e => {
            commit('addNotification', {
                type: 'error',
                message: _.get(e, 'response.data.message', 'Could not add quote item'),
            });

            throw e;
        });
    },

    addNotification({ commit }, payload) {
        commit('addNotification', payload);
    },

    createDeliveryAddress({ commit }, data) {
        return api.postData('/my/account/delivery_addresses', {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Delivery address has been created',
                });
                commit('addDeliveryAddress', res);
                return res;
            })
    },

    updateDeliveryAddresses({ commit }, payload) {
        const { data } = payload;

        return api.putData('/my/account/delivery_addresses', {}, { data })
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Delivery address has been updated',
                });
                commit('updateDeliveryAddresses', res);
                return res;
            })
    },

    setFreeShipping({ commit, dispatch }, payload) {
        payload = _.isNull(payload) ? true : payload;
        const { free_shipping } = payload;
        commit('setFreeShipping', free_shipping);
        return free_shipping;
    },

    setShippingThreshold({ commit, dispatch }, payload) {
        payload = _.isNull(payload) ? 300 : payload;
        const { shipping_threshold } = payload;
        commit('setShippingThreshold', shipping_threshold);
        return shipping_threshold;
    },

    setShippingCost({ commit, dispatch }, payload) {
        payload = _.isNull(payload) ? 10 : payload;
        const { shipping_cost } = payload;
        commit('setShippingCost', shipping_cost);
        return shipping_cost;
    },

    setExpressCost({ commit, dispatch }, payload) {
        payload = _.isNull(payload) ? 20 : payload;
        const { express_cost } = payload;
        commit('setExpressCost', express_cost);
        return express_cost;
    },

    addFavouriteProduct({ commit }, data) {
        return api.postData('/my/favourite_product_entries', {}, data)
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Product has been added to wish list',
                });
                commit('addFavouriteProduct', res);
                return res;
            })
    },

    removeFavouriteProduct({ commit }, payload) {
        const { id } = payload;

        return api.delData(`/my/favourite_product_entry/${id}`, {})
            .then(res => {
                commit('addNotification', {
                    type: 'message',
                    message: 'Product has been removed from wish list',
                });
                commit('removeFavouriteProduct', res);
                return res;
        })
    },

    setRuralDisabled({ commit, dispatch }, payload) {
        const { disable_rural } = payload;
        commit('setRuralDisabled', disable_rural);
        return disable_rural;
    },

    setBulkyDisabled({ commit, dispatch }, payload) {
        const { disable_bulky } = payload;
        commit('setBulkyDisabled', disable_bulky);
        return disable_bulky;
    },
}

// mutations
const mutations = {
    setOrder(state, order) {
        _.set(state, 'order', order);
        _.set(state, 'timestamp', Date.now());
    },

    setFreeShipping(state, free_shipping) {
        _.set(state, 'free_shipping', free_shipping);
    },

    setShippingThreshold(state, shipping_threshold) {
        _.set(state, 'shipping_threshold', shipping_threshold);
    },

    setShippingCost(state, shipping_cost) {
        _.set(state, 'shipping_cost', shipping_cost);
    },

    setExpressCost(state, express_cost) {
        _.set(state, 'express_cost', express_cost);
    },

    setRuralDisabled(state, disable_rural) {
        _.set(state, 'disable_rural', disable_rural);
    },

    setBulkyDisabled(state, disable_bulky) {
        _.set(state, 'disable_bulky', disable_bulky);
    },

    setProduct(state, response) {
        _.set(state, 'product', response);
        _.set(state, 'timestamp', Date.now());
    },

    updateProfile(state, response) {
        _.set(state, 'customer', response);
        _.set(state, 'timestamp', Date.now());
    },

    updateCustomer(state, response) {
        _.set(state, 'customer', response);
        _.set(state, 'timestamp', Date.now());
    },

    setCart(state, cart) {
        _.set(state, 'cart', cart);
        _.set(state, 'timestamp', Date.now());
    },

    setCartAttribute(state, cart) {
        const attributes = _.chain(state).get('cart.attributes').merge(_.get(cart, 'attributes', {})).value();
        _.set(state, 'cart.attributes', attributes);
        _.set(state, 'timestamp', Date.now());
    },

    updateCart(state, response) {
        _.set(state, 'cart', response);
        _.set(state, 'timestamp', Date.now());
    },

    updateCartAttributes(state, response) {
        _.set(state, 'cart.attributes', _.get(response, 'attributes', {}));
        _.set(state, 'timestamp', Date.now());
    },

    createCart(state, response) {
        const carts = _.get(state, 'carts.data', []);
        _.set(state, 'carts.data', _.concat(carts, [response]));
        _.set(state, 'timestamp', Date.now());
    },

    deleteCart(state, response) {
        const carts = _.get(state, 'carts.data', []);
        _.set(state, 'carts.data', _.reject(carts, (c) => c.id == response.id));
        _.set(state, 'timestamp', Date.now());
    },

	setCartItems(state, response) {
        _.set(state, 'cart.included.items', response);
        _.set(state, 'timestamp', Date.now());
	},

    updateCartItems(state, data) {
        let items = _.get(state, 'cart.included.items.data', []);

        _.forEach(data, (item) => {
            /*||*/ if (_.has(item, '$created')) {
                items = _.concat(items, item.$created);

            } else if (_.has(item, '$updated')) {
                const idx = _.findIndex(items, (it) => it.id == item.id);
                items[idx] = item.$updated;

            } else if (_.has(item, '$deleted')) {
                items = _.reject(items, (it) => it.id == item.id);
            }
        })

        _.set(state, 'cart.included.items.data', items);
        _.set(state, 'timestamp', Date.now());
    },

    setQuote(state, quote) {
        _.set(state, 'quote', quote);
    },

    setQuotes(state, quotes) {
        _.set(state, 'quotes', quotes);
        _.set(state, 'timestamp', Date.now());
    },

    setQuoteAttribute(state, quote) {
        const attributes = _.chain(state).get('quote.attributes').merge(_.get(quote, 'attributes', {})).value();
        _.set(state, 'quote.attributes', attributes);
        _.set(state, 'timestamp', Date.now());
    },

    updateQuote(state, response) {
        _.set(state, 'quote', response);
        _.set(state, 'timestamp', Date.now());
    },

    updateQuoteAttributes(state, response) {
        _.set(state, 'quote.attributes', _.get(response, 'attributes', {}));
        _.set(state, 'timestamp', Date.now());
    },

    createQuote(state, response) {
        const quotes = _.get(state, 'quotes.data', []);
        _.set(state, 'quotes.data', _.concat(quotes, [response]));
        _.set(state, 'timestamp', Date.now());
    },

    deleteQuote(state, response) {
        const quotes = _.get(state, 'quotes.data', []);
        _.set(state, 'quotes.data', _.reject(quotes, (c) => c.id == response.id));
        _.set(state, 'timestamp', Date.now());
    },

	setQuoteItems(state, response) {
        _.set(state, 'quote.included.items', response);
        _.set(state, 'timestamp', Date.now());
	},

    updateQuoteItems(state, data) {
        let items = _.get(state, 'quote.included.items.data', []);

        _.forEach(data, (item) => {
            /*||*/ if (_.has(item, '$created')) {
                items = _.concat(items, item.$created);

            } else if (_.has(item, '$updated')) {
                const idx = _.findIndex(items, (it) => it.id == item.id);
                items[idx] = item.$updated;

            } else if (_.has(item, '$deleted')) {
                items = _.reject(items, (it) => it.id == item.id);
            }
        })

        _.set(state, 'quote.included.items.data', items);
        _.set(state, 'timestamp', Date.now());
    },

    addDeliveryAddress(state, response) {
        let data = _.get(state, 'customer.included.delivery_addresses.data', []);
        data = _.concat(data, response);

        _.set(state, 'customer.included.delivery_addresses.data', data);
        _.set(state, 'timestamp', Date.now());
    },

    updateDeliveryAddresses(state, response) {
        const { updated, deleted, attached, detached } = response.meta;

        let data = _.get(state, 'customer.included.delivery_addresses.data', []);

        // replacing updated items
        data = _.map(data, item => {
            const replacingItem = _.find(response.data, (itemData => itemData.id == item.id));
            return replacingItem || item;
        });

        // filter out deleted items
        data = _.filter(data, item => {
            return _.indexOf(deleted, item.id) < 0;
        });

        // add items attached
        data = _.concat(data, _.filter(response.data, item => _.indexOf(attached, item.id) >= 0));

        // filter out detached items
        data = _.filter(data, item => _.indexOf(detached, item.id) < 0);

        _.set(state, 'customer.included.delivery_addresses.data', data);
        _.set(state, 'timestamp', Date.now());
    },

    addNotification(state, payload) {
        _.set(state, 'notifications', _.concat(state.notifications, [payload]));
    },

    addFavouriteProduct(state, response) {
        let data = _.get(state, 'favourite_product_entries.data', []);
        data = _.concat(data, response);

        _.set(state, 'favourite_product_entries.data', data);
        _.set(state, 'timestamp', Date.now());
    },

    removeFavouriteProduct(state, response) {
        let data = _.get(state, 'favourite_product_entries.data', []);
        data = _.filter(data, (item => item.id != response.id));

        _.set(state, 'favourite_product_entries.data', data);
        _.set(state, 'timestamp', Date.now());
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
